import { Decimal } from 'decimal.js';

/**
 * Geldarithmetik der Preisengine.
 *
 * PRICING-ENGINE.md Abschnitt 10: Zwischenwerte als Dezimaltyp mit mindestens sechs
 * Nachkommastellen, **nie Fliesskomma**. Ein falscher Preis in einem versendeten
 * Dokument ist ein kaufmaennischer Vorgang, kein Bug.
 */
Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_UP });

export { Decimal };

/** Zulaessige Eingabeform fuer Betraege und Mengen. */
export type Numeric = string | number | Decimal;

export const ZERO = new Decimal(0);

export function dec(value: Numeric): Decimal {
  return value instanceof Decimal ? value : new Decimal(value);
}

/** Kaufmaennisch auf zwei Nachkommastellen, also halbe Beträge aufgerundet. */
export function round2(value: Decimal): Decimal {
  return value.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}

/**
 * Kaufmaennisch auf drei Nachkommastellen. G-ST-P/OE, ADR-0022: Rundung der
 * Profilgesamtlaenge -- ausschliesslich am Gesamtergebnis, nie an Zwischenwerten
 * wie der Laenge je Dichtung.
 */
export function round3(value: Decimal): Decimal {
  return value.toDecimalPlaces(3, Decimal.ROUND_HALF_UP);
}

/** Nettopreis aus Listenpreis und Rabattsatz. Rundung erst am Ende. */
export function applyDiscount(listPrice: Decimal, discountPercent: Numeric): Decimal {
  return listPrice.times(new Decimal(100).minus(dec(discountPercent))).dividedBy(100);
}
